<script setup lang="ts">
import { SortButtonOrder } from '@spectee/types/atoms';
import Icon from '@spectee/components/Atoms/IconBase/index.vue';
import Tooltip from '@spectee/components/Atoms/Tooltip/index.vue';

defineExpose({
  name: 'SortButton',
});

interface Props {
  order?: SortButtonOrder;
  priority?: number;
  text?: string;
  direction?: string;
}

const props = withDefaults(defineProps<Props>(), {
  order: 0,
});

const SORT_ICON_NAME: { [key: number]: string } = {
  0: 'SortDefault',
  1: 'SortUp',
  2: 'SortDown',
};
</script>

<template>
  <Tooltip
    class="SortButton"
    :class="[{ 'SortButton--priority': priority }]"
    :text="text ? text : ''"
    :direction="direction"
  >
    <button class="SortButton__button" aria-label="ソート">
      <Icon class="SortButton__icon" :iconName="SORT_ICON_NAME[order]" />
      <span v-if="priority" class="SortButton__priority">{{ priority }}</span>
    </button>
  </Tooltip>
</template>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.SortButton {
  width: $service-unit * 4;
  height: $service-unit * 4;

  &--priority {
    width: $service-unit * 8;
  }

  &__button {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    background-color: transparent;
  }

  & &__icon {
    width: $service-unit * 4;
    height: $service-unit * 4;
  }

  &__priority {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: $service-unit * 4;
    height: $service-unit * 4;
    font-size: $service-font-size-ppp;
    font-weight: bold;
    vertical-align: text-top;
    background-color: $color-gray-40;
    border-radius: $service-border-radius-circle;
  }
}
</style>
